import rewardsAPI from '@/api/rewards-api.js'

export default {
  state: {
    engagementInfo: null,
    isHistoryViewed: true,
    showLoyaltySectionLoader: false,
    pointsHistoryList: [],
    rewardData: {},
    giftList: [],
    redeemedHistoryList: []
  },
  getters: {
    getEngagementInfo (state) {
      return state.engagementInfo
    },
    getIsHistoryViewed (state) {
      return state.isHistoryViewed
    },
    getShowLoyaltySectionLoader (state) {
      return state.showLoyaltySectionLoader
    },
    getPointsHistoryListWithoutReduce (state) {
      return state.pointsHistoryList
    },
    getPointsHistoryList (state) {
      return state.pointsHistoryList.reduce((accumulator, record) => {
        const date = record.createdDate.split('T')[0]
        if (!accumulator[date]) {
          accumulator[date] = []
        }
        accumulator[date].push(record)
        return accumulator
      }, {})
    },
    getRewardData (state) {
      return state.rewardData
    },
    getGiftList (state) {
      return state.giftList
    },
    getRedeemedHistoryList (state) {
      return state.redeemedHistoryList
    }
  },
  mutations: {
    setEngagementInfo (state, value) {
      state.engagementInfo = value
    },
    setIsHistoryViewed (state, value) {
      state.isHistoryViewed = value
    },
    setShowLoyaltySectionLoader (state, value) {
      state.showLoyaltySectionLoader = value
    },
    setPointsHistoryList (state, value) {
      state.pointsHistoryList = value
    },
    setRewardData (state, value) {
      state.rewardData = value
    },
    setGiftList (state, value) {
      state.giftList = value
    },
    setRedeemedHistoryList (state, value) {
      state.redeemedHistoryList = value
    },
    resetGiftList (state) {
      state.giftList = []
    },
    resetRedeemedHistory (state) {
      state.redeemedHistoryList = []
    },
    resetState (state) {
      const initialState = {
        engagementInfo: null,
        isHistoryViewed: true,
        showLoyaltySectionLoader: false,
        pointsHistoryList: [],
        rewardData: {},
        giftList: [],
        redeemedHistoryList: []
      }
      Object.assign(state, initialState)
    }
  },
  actions: {
    ADD_SCANNED_PRODUCT (_, { data, success, fail }) {
      rewardsAPI.addScannedProduct(data).then(res => {
        const resBody = res.body
        if (resBody && resBody.success && resBody.errorCode === null) {
          success && success(resBody)
        } else {
          fail && fail(res)
        }
      }).catch(err => {
        fail && fail(err)
      })
    },
    SCANNED_PRODUCT_LIST (_, { query, success, fail }) {
      rewardsAPI.scannedProductList(query).then(res => {
        const resBody = res.body
        if (resBody && resBody.success && resBody.errorCode === null) {
          success && success(resBody)
        } else {
          fail && fail(res)
        }
      },
      err => {
        fail && fail(err)
      }
      )
    },
    DOWNLOAD_PRODUCTS (_, { query, success, fail }) {
      rewardsAPI.downloadProducts(query).then(res => {
        const resBody = res.body
        success && success(resBody)
      }, err => {
        fail && fail(err)
      })
    },
    UPLOAD_PRODUCTS (_, { data, success, fail }) {
      rewardsAPI.uploadProducts(data).then(res => {
        const resBody = res.body
        if (resBody && resBody.success && resBody.errorCode === null) {
          success && success(resBody)
        } else {
          fail && fail(resBody)
        }
      }, err => {
        fail && fail(err)
      })
    },
    GET_ENGAGEMENT_INFO ({ commit }, { param, success, fail }) {
      commit('setShowLoyaltySectionLoader', true)
      rewardsAPI.getEngagementInfo(param).then(
        res => {
          const resBody = res.body
          commit('setShowLoyaltySectionLoader', false)
          if (resBody && resBody.success) {
            const responseValue = resBody?.value || null
            commit('setEngagementInfo', responseValue)
            commit('setIsHistoryViewed', responseValue?.memberLoyaltyResponse?.isHistoryViewed)
            commit('npsStore/setShowNpsPopup', responseValue?.feedbackResponse?.triggerFeedback, { root: true })
            commit('npsStore/setFeedbackId', responseValue?.feedbackResponse?.feedBackId || null, { root: true })
            success && success(responseValue)
          } else {
            fail && fail()
          }
        },
        err => {
          commit('setShowLoyaltySectionLoader', false)
          fail && fail(err)
        }
      )
    },
    GET_POINTS_HISTORY ({ state, commit }, { query, success, fail }) {
      rewardsAPI.getPointsHistory(query).then(
        res => {
          const resBody = res.body
          if (resBody && resBody.success) {
            const currentResponse = resBody.content || []
            commit('setPointsHistoryList', state.pointsHistoryList.concat(currentResponse))
            success && success(resBody.pageMetaData)
          } else {
            fail && fail()
          }
        },
        err => {
          fail && fail(err)
        }
      )
    },
    GET_SCANNED_PRODUCT_DETAIL ({ commit }, { data, success, fail }) {
      rewardsAPI.getScannedProductDetail(data).then(res => {
        commit('setRewardData', res.body.value)
        const resBody = res.body
        if (resBody && resBody.success && resBody.errorCode === null) {
          success && success(resBody)
        } else {
          fail && fail(res)
        }
      },
      err => {
        fail && fail(err)
      }
      )
    },
    UPLOAD_INVOICE (_, { data, success, fail }) {
      rewardsAPI.uploadInvoice(data).then(res => {
        const resBody = res.body
        if (resBody && resBody.success && resBody.errorCode === null) {
          success && success(resBody)
        } else {
          fail && fail(res)
        }
      }, err => {
        fail && fail(err)
      })
    },
    GET_GIFT_LIST ({ state, commit }, { query, success, fail }) {
      rewardsAPI.getGiftList(query).then(
        res => {
          const resBody = res.body
          if (resBody && resBody.success) {
            const currentResponse = resBody.content || []
            commit('setGiftList', state.giftList.concat(currentResponse))
            success && success(resBody.pageMetaData)
          } else {
            fail && fail()
          }
        },
        err => {
          fail && fail(err)
        }
      )
    },
    REDEEM_GIFT ({ commit }, { payload, success, fail }) {
      rewardsAPI.redeemGift(payload).then(res => {
        const resBody = res.body
        if (resBody && resBody.success && resBody.errorCode === null) {
          commit('setEngagementInfo', resBody.value.activePoint)
          commit('setIsHistoryViewed', resBody.value?.isHistoryViewed)
          success && success(resBody)
        } else {
          fail && fail(res.body)
        }
      }).catch(err => {
        fail && fail(err)
      })
    },
    GET_REDEEMED_GIFT_DETAILS (_, { query, success, fail }) {
      rewardsAPI.getRedeemedGiftDetails(query).then(res => {
        const resBody = res.body
        if (resBody && resBody.success && resBody.errorCode === null) {
          success && success(resBody.value)
        } else {
          fail && fail(resBody)
        }
      }).catch(err => {
        fail && fail(err)
      })
    },
    GET_REDEEMED_HISTORY ({ state, commit }, { query, success, fail }) {
      rewardsAPI.getRedeemedHistory(query).then(
        res => {
          const resBody = res.body
          if (resBody && resBody.success) {
            const currentResponse = resBody.content || []
            commit('setRedeemedHistoryList', state.redeemedHistoryList.concat(currentResponse))
            success && success(resBody.pageMetaData)
          } else {
            fail && fail()
          }
        },
        err => {
          fail && fail(err)
        }
      )
    }
  },
  namespaced: true
}

